<script>
import {get} from "../../../public/js/vendor/list";

export default {
  name: "UiSwitch",
  props: {
    modelValue: Boolean,
    label: {
      type: String,
      default: ""
    },
    inputId: {
      type: String,
      default: () => `switch-${Math.random().toString(36).substr(2, 5)}`
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue || null;
      },
      set(value) {
        this.$emit('update:modelValue', value);
        this.$emit('change', value);
      }
    }
  }
};
</script>


<template>
  <div class="form-check form-switch">
    <input
        class="form-check-input"
        type="checkbox"
        :id="inputId"
        v-model="internalValue"
    />
    <label class="form-check-label" :for="inputId">
      {{ label }}
    </label>
  </div>
</template>


<style scoped>
.form-check-input {
  cursor: pointer;
}

.form-check-label {
  cursor: pointer;
  margin-left: 0.5rem;
}
</style>
